import {
  ReservationActionTypes,
  CompleteReservationInfo,
  PropertyFeesResponse,
  ReservationPropertyFeesAction,
} from "./../../actionTypes/reservation/types";
import {
  ADD_RESERVATIONS,
  UPDATE_APP_MODE,
  SET_BLACKLIST,
  SET_BLACKLIST_RECOVERY,
  SET_SUPER_BLACKLIST,
  SET_RECOVERY_PAYMENT_CLEARED,
  SET_PROPERTY_FEES,
  SET_CURRENT_RESERVATION_ID,
} from "./../../actionTypes/reservation";
import { AppMode } from "../../../../enums";

export function addReservations(
  extendedReservations: CompleteReservationInfo[]
): ReservationActionTypes {
  return { type: ADD_RESERVATIONS, reservations: extendedReservations };
}

export function updateAppMode(appMode: AppMode): ReservationActionTypes {
  return { type: UPDATE_APP_MODE, appMode: appMode };
}

// export function setPropertyFees(response: PropertyFeesResponse): ReservationPropertyFeesAction {
//   return { type: SET_PROPERTY_FEES, propertyFees: response };
// }

export const getPropertyFees = (data: { amount: number }, propertyId: string | number) => ({
  type: SET_PROPERTY_FEES,
  payload: {
    client: "default",
    request: {
      url: `/v1/property/${propertyId}/feesForProperty`,
      method: "post",
      data,
    },
  },
});
export function setBlacklist(value: boolean) {
  return { type: SET_BLACKLIST, isBlacklisted: value };
}

export function setRecoveryPaymentCleared(value: boolean) {
  return { type: SET_RECOVERY_PAYMENT_CLEARED, isRecoveryPaymentCleared: value };
}

export function setBlacklistRecovery(value: boolean) {
  return { type: SET_BLACKLIST_RECOVERY, isBlacklistedRecovery: value };
}

export function setSuperBlacklist(value: boolean) {
  return { type: SET_SUPER_BLACKLIST, isSuperBlacklist: value };
}

export function setCurrentReservationId(reservationId: any) {
  return {
    type: SET_CURRENT_RESERVATION_ID,
    currentReservationId: reservationId,
  };
}